module.exports = __webpack_public_path__ + "img/yes.f54a6345.svg";